import React from 'react';
import { Card } from '@/components/ui';
import type { SystemKPIs } from '../../types/dashboard.types';

interface SuperAdminKPIGridProps {
  kpis?: SystemKPIs;
}

export function SuperAdminKPIGrid({ kpis }: SuperAdminKPIGridProps) {
  if (!kpis) return null;

  const data = [
    { title: 'Tổ chức', value: (kpis.totalTenants || 0).toLocaleString(), subValue: 'Tổng số tổ chức', trend: 'up', trendValue: `+ ${kpis.trends?.tenants || 0}% so với kỳ trước`, icon: 'ri-building-2-line', color: 'text-blue-500', bg: 'bg-blue-50' },
    { title: 'Người dùng', value: (kpis.totalUsers || 0).toLocaleString(), subValue: 'Tổng số người dùng', trend: 'up', trendValue: `+ ${kpis.trends?.users || 0}% so với kỳ trước`, icon: 'ri-group-line', color: 'text-purple-500', bg: 'bg-purple-50' },
    { title: 'Dự án', value: (kpis.totalProjects || 0).toLocaleString(), subValue: 'Tổng số dự án', trend: 'up', trendValue: `+ ${kpis.trends?.projects || 0}% so với kỳ trước`, icon: 'ri-file-copy-2-line', color: 'text-blue-400', bg: 'bg-blue-50' },
    { title: 'Doanh thu (VNĐ)', value: `${kpis.totalRevenue || 0} tỷ`, subValue: 'Tổng doanh thu', trend: 'up', trendValue: `+ ${kpis.trends?.revenue || 0}% so với kỳ trước`, icon: 'ri-money-dollar-circle-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
    { title: 'Gói dịch vụ', value: (kpis.activePlans || 0).toString(), subValue: 'Tổ chức đang hoạt động', trend: 'neutral', trendValue: '', icon: 'ri-survey-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
    { title: 'Tỷ lệ hoạt động', value: `${kpis.uptimePct || 0}%`, subValue: 'Hệ thống hoạt động ổn định', trend: 'neutral', trendValue: '', icon: 'ri-line-chart-line', color: 'text-purple-400', bg: 'bg-purple-50' },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-5 mb-6">
      {data.map((item, idx) => (
        <Card key={idx} className="p-5 border-slate-100 shadow-sm hover:shadow-md transition-shadow bg-white flex flex-col gap-4">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${item.bg} ${item.color}`}>
              <i className={`${item.icon} text-xl`} />
            </div>
            <div>
              <p className="sm:text-sm text-xs font-medium text-slate-500 mb-0.5">{item.title}</p>
              <h3 className="text-2xl font-black text-slate-900 tracking-tight">{item.value}</h3>
            </div>
          </div>
          <div className="pt-3 border-t border-slate-50">
            <p className="sm:text-sm text-xs font-medium text-slate-400 mb-1.5">{item.subValue}</p>
            {item.trend !== 'neutral' && (
              <p className="sm:text-sm text-xs font-medium text-emerald-500 flex items-center gap-1">
                <i className={item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} />
                {item.trendValue}
              </p>
            )}
            {item.trend === 'neutral' && !item.trendValue && (
              <p className="sm:text-sm text-xs font-medium text-slate-400">&nbsp;</p>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
}
